import React from 'react';
import PropTypes from 'prop-types';
import { handleAnchor } from '../../../utils/helpers';
import { logProductClickEvent } from '../../../utils/tracking';

const CardLink = ({ anchorName, url, trackingProduct, children }) => {
  const onClick = () => {
    handleAnchor(anchorName);
    logProductClickEvent(trackingProduct);
  };
  return (
  <a className='vf-card-link' onClick={onClick} href={url}>
    { children }
  </a>
  );
};

CardLink.propTypes = {
  anchorName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  trackingProduct: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default CardLink;